import adLoader from './ad-loader';
import { h, render } from 'preact';

import App from './components/app';

render(
  <App />,
  document.getElementById('app')
);

adLoader();



// WEBPACK FOOTER //
// ./main.js